const ROUTE_PATHS = {
    home: '/',
    about: '/about',
    products: '/products',
    productDetail: '/products/:productId',
    FAQ: '/faq',
    contact: '/contact',
    solutions: '/app/solutions',
    regenerativeMedicine: '/regenerativeMedicine',
    orderDetails: '/app/orderDetails',
    shoppingCart: '/app/shoppingCart',
    orderSuccess: '/app/orderSuccess',
    privacyPolicy: '/privacyPolicy',
    termsAndConditions: '/termsAndConditions',
    returnPolicy: '/returnPolicy',
    createAccount: '/account/createAccount',
    accountSuccess: '/account/accountSuccess',
    createClinic: '/account/createClinic',
    emailSuccess: '/account/emailSuccess',
    clinicSuccess: '/account/clinicSuccess',
    clinicDetails: '/clinicDetails',
    clinicOrders: '/orders',
    clinicOrderDetails: '/orders/:orderId',
    login: '/account/login',
    forgotPassword: '/account/forgot-password',
    resetPassword: '/account/reset-password',
    clinicApproval: '/account/clinicApproval',
    verifyEmail: '/account/verify-email',
    admin: '/web-admin',
    adminClinics: '/web-admin/clinics',
    adminClinicCreate: '/web-admin/clinics/new',
    adminClinicDetails: '/web-admin/clinics/:clinicId',
    adminUsers: '/web-admin/users',
    adminClinicUsers: '/web-admin/clinic-users',
    adminOrders: '/web-admin/orders',
    adminOrderDetails: '/web-admin/orders/:orderId',
    adminProducts: '/web-admin/products',
    adminProductCategories: '/web-admin/product-categories',
    adminShippingMethods: '/web-admin/shipping-methods',
    adminManufacturerShipping: '/web-admin/manufacturer-shipping',
    adminProductDetails: '/web-admin/products/:productId',
    adminProductNew: '/web-admin/products/new',
    adminOrderBatching: '/web-admin/order-batching',
    adminPromoCodes: '/web-admin/promo-codes',
    adminPromoCodeUsages: '/web-admin/promo-code-usages',
    adminCorporateGroups: '/web-admin/corporate-groups',
    adminSalesReps: '/web-admin/sales-reps',
    adminPromoCodeNew: '/web-admin/promo-codes/new',
    adminPromoCodeDetails: '/web-admin/promo-codes/:promoCodeId',
    adminBioPage: '/web-admin/bio-page',
};
export default ROUTE_PATHS;
